import React, { useEffect } from 'react';

import BlogPostExcerptCard from '../../cards/BlogPostExcerptCard/BlogPostExcerptCard';
import Pagination from '../../../shared/Pagination/Pagination';

import './BlogPostExcerptsList.css';

const BlogPostExcerptsList = ({
  blogPosts,
  totalPosts,
  postsPerPage = 6,
  currentPage,
  setCurrentPage,
  isLoading,
}) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);

  return (
    <div className='blog-post-excerpts-list-container'>
      <div className='blog-post-excerpts-list'>
        {blogPosts?.map((blogPost) => (
          <div key={blogPost._id}>
            <BlogPostExcerptCard blogPost={blogPost} />
            <hr className='blog-divider' />
          </div>
        ))}

        {!isLoading && !blogPosts?.length && (
          <span className='blog-post-excerpts-list-no-blog-yet'>
            No blog posts yet.
          </span>
        )}
      </div>

      {!!totalPosts && (
        <Pagination
          totalPosts={totalPosts}
          postsPerPage={postsPerPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}
    </div>
  );
};

export default BlogPostExcerptsList;
